// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-25 {
    width: 25%;
}

.w-50 {
    width: 50%;
}

.w-15 {
    width: 15%;
}

.w-10 {
    width: 10%;
}
/* Define uma largura mínima para campos que não devem encolher */
.input-fixo {
    min-width: 250px; /* Ajuste conforme necessário */
}

/* Ajusta campos para preencher a largura apenas em telas pequenas */
@media (max-width: 576px) {
    .input-100 {
        width: 100% !important;
    }
}

/* Adicione isso ao seu arquivo Cliente.css ou crie um novo arquivo CSS para a tabela */

.table-container {
  max-height: calc(100vh - 200px); /* Ajuste este valor conforme necessário */
  overflow-y: auto;
  margin-bottom: 20px;
  display: block;
}

.table-container table {
  border-collapse: separate;
  border-spacing: 0;
}

.table-container thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #e2e3e5;
}

.table-responsive-sm table {
  border-collapse: separate;
  border-spacing: 0;
}

.table-responsive-sm thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #e2e3e5;
}

.table-responsive table {
  border-collapse: separate;
  border-spacing: 0;
}

.table-responsive thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #e2e3e5;
}

.table-responsive-sm {
  display: block;
  width: 100%;
  overflow-x: auto;
}

h6.fw-bold.text-dark {
  text-shadow: 
    -1px -1px 0 rgba(255, 255, 255, 0.8),
    1px -1px 0 rgba(255, 255, 255, 0.8),
    -1px 1px 0 rgba(255, 255, 255, 0.8),
    1px 1px 0 rgba(255, 255, 255, 0.8);
}

h5.text-dark {
  text-shadow: 
    -1px -1px 0 rgba(255, 255, 255, 0.8),
    1px -1px 0 rgba(255, 255, 255, 0.8),
    -1px 1px 0 rgba(255, 255, 255, 0.8),
    1px 1px 0 rgba(255, 255, 255, 0.8);
}

.full-screen-div {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container.mt-4.pt-5 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

`, "",{"version":3,"sources":["webpack://./src/service/css/Cliente.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;AACA,iEAAiE;AACjE;IACI,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA,oEAAoE;AACpE;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA,uFAAuF;;AAEvF;EACE,+BAA+B,EAAE,0CAA0C;EAC3E,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;;;;sCAIoC;AACtC;;AAEA;EACE;;;;sCAIoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".w-25 {\r\n    width: 25%;\r\n}\r\n\r\n.w-50 {\r\n    width: 50%;\r\n}\r\n\r\n.w-15 {\r\n    width: 15%;\r\n}\r\n\r\n.w-10 {\r\n    width: 10%;\r\n}\r\n/* Define uma largura mínima para campos que não devem encolher */\r\n.input-fixo {\r\n    min-width: 250px; /* Ajuste conforme necessário */\r\n}\r\n\r\n/* Ajusta campos para preencher a largura apenas em telas pequenas */\r\n@media (max-width: 576px) {\r\n    .input-100 {\r\n        width: 100% !important;\r\n    }\r\n}\r\n\r\n/* Adicione isso ao seu arquivo Cliente.css ou crie um novo arquivo CSS para a tabela */\r\n\r\n.table-container {\r\n  max-height: calc(100vh - 200px); /* Ajuste este valor conforme necessário */\r\n  overflow-y: auto;\r\n  margin-bottom: 20px;\r\n  display: block;\r\n}\r\n\r\n.table-container table {\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n}\r\n\r\n.table-container thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  background-color: #e2e3e5;\r\n}\r\n\r\n.table-responsive-sm table {\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n}\r\n\r\n.table-responsive-sm thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  background-color: #e2e3e5;\r\n}\r\n\r\n.table-responsive table {\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n}\r\n\r\n.table-responsive thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  background-color: #e2e3e5;\r\n}\r\n\r\n.table-responsive-sm {\r\n  display: block;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\nh6.fw-bold.text-dark {\r\n  text-shadow: \r\n    -1px -1px 0 rgba(255, 255, 255, 0.8),\r\n    1px -1px 0 rgba(255, 255, 255, 0.8),\r\n    -1px 1px 0 rgba(255, 255, 255, 0.8),\r\n    1px 1px 0 rgba(255, 255, 255, 0.8);\r\n}\r\n\r\nh5.text-dark {\r\n  text-shadow: \r\n    -1px -1px 0 rgba(255, 255, 255, 0.8),\r\n    1px -1px 0 rgba(255, 255, 255, 0.8),\r\n    -1px 1px 0 rgba(255, 255, 255, 0.8),\r\n    1px 1px 0 rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.full-screen-div {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n}\r\n\r\n.container.mt-4.pt-5 {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
